import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';
import Link from 'components/Link';

const CommentsList = props => {

  function handleFollow(event) {
    event.preventDefault();
    props.onFollow && props.onFollow();
  }

  function handleUnfollow(event) {
    event.preventDefault();
    props.onFollow && props.onUnfollow();
  }

  function handleSortOptionChange(event) {
    props.onSortOptionChange && props.onSortOptionChange(event.target.value);
  }

  return (
    <div className="CommentsList">
      <div className="filter">

        <div className={classnames('float-left', {hide: !props.allowsSorting})}>
          <form>
            <label htmlFor="sortOptions">{__('members.comments.sortOptions.title')}</label>

            <select name="sortOptions" value={props.selectedSortOption} onChange={handleSortOptionChange}>
              {props.sortOptionsPairs && props.sortOptionsPairs.map(pair => <option key={pair.value} value={pair.value}>{pair.title}</option>)}
            </select>
          </form>
        </div>

        <div className="float-right">
          {(() => {
            if(props.isFollowed) {
              return <Link onClick={handleUnfollow} to="_">{__('members.comments.unfollowReplies')}</Link>;
            }

            return <Link onClick={handleFollow} to="_">{__('members.comments.followReplies')}</Link>;
          })()}
        </div>
      </div>

      <div className="list">
        {props.children}
      </div>
    </div>
  );
};

CommentsList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  allowsSorting: PropTypes.bool,
  sortOptionsPairs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    title: PropTypes.string
  })),
  selectedSortOption: PropTypes.string,
  isFollowed: PropTypes.bool,
  onSortOptionChange: PropTypes.func,
  onFollow: PropTypes.func,
  onUnfollow: PropTypes.func
};

export default CommentsList;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/CommentsList/index.js
 **/